import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import CustomButton from "../../Common/CustomButton";
import DetailsContainer from "../../Common/DetailsContainer";
import CapturedPhotosContainer from "../CapturedPhotosContainer";
import FrResults from "../LiveEvents/FrResults";
import ProfileViewMatched from "../../Profiles/ProfileView/ProfileViewMatched";
import ProfileLink from "../../Common/ProfileLink";
import WearingMask from "../../Common/WearingMask";

import { isUnknownProfile } from "../../../utils/profile";
import { formatDate } from "../../../utils/date";
import { fetchPut } from '../../../api/fetch';

import { FACE_DETECT, human } from "../../../constants/common";
import MessageDialog from "../../Common/MessageDialog";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const LogDetailsDriverNew = (props) => {
  const { classes,onRemovingTab } = props;
  const { log, lov, fr, contextPhotos } = props.details;
  const [frResultsOpen, setFrResultsOpen] = React.useState(false);
  const [overrideOpen, setOverrideOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const getPhotos = () => {
    const deepIncludes = (arr, item) => {
      let res = false;
      arr.forEach((i) => {
        if (i.includes(item) || item.includes(i)) {
          res = true;
        }
      });
      return res;
    };

    let photoNames = [];
    let frPhotos = [];
    if (fr) {
      fr.sort((a, b) => (a.faceRecognized ? -1 : 1)).forEach((rec) => {
        let url = get(rec, ["img", 0, "url"]);
        if (!deepIncludes(photoNames, url)) {
          photoNames.push(url);
          frPhotos.push({
            url,
            type: FACE_DETECT,
            values: [],
            matched: rec.faceRecognized,
          });
        }
      });
    }

    let contphotos = [];
    if (contextPhotos) {
      contextPhotos.forEach((c) => {
        if (!deepIncludes(photoNames, c.url)) {
          photoNames.push(c.url);
          contphotos.push({
            url: c.url,
            type: c.type,
            values: [],
            matched: false,
          });
        }
      });
    }

    return [...contphotos, ...frPhotos];
  };

  return (
    <Grid container direction="column" alignItems="stretch" wrap="nowrap">
      {get(props, ["details", "override"]) && (
        <Grid
          item
          xs
          className="flexCenter"
          style={{
            justifyContent: "flex-end",
            paddingRight: "10px",
            color: colors.black54,
          }}
        >
          {`${I18n.get("site_overridenBy")} ${get(props, [
            "details",
            "override",
            "overriden_by",
          ])}, ${formatDate(
            get(props, ["details", "override", "created_on"])
          )}`}
        </Grid>
      )}
      <Grid item style={{ height: "30px", marginBottom: "20px" }}>
        <Grid container>
          <Grid item xs={4} />
          <ProfileLink
            profile={get(log, ["profile"])}
            overriden={get(props, ["details", "override"])}
            type={get(props, ["type"]) || human}
            score={get(props, ["details", "lukeIndex"])}
          />
          <Grid
            item
            xs={4}
            className="flexCenter"
            style={{
              justifyContent: "flex-end",
              paddingRight: "10px",
              color: colors.black54,
            }}
          >
               <CustomButton
                onClick={() => setOpen(true)}
                startIcon={<img src={images.removeIcon} />}
              ><></></CustomButton>
             <MessageDialog
                open={open}
                message={I18n.get("profile_remove")}
                isEvent={true}
                onClose={async (flag) => {
                  if (flag) {
                    let eventGroupId = get(log, ["id"]);
                    await fetchPut(`event_groups/${eventGroupId}`, {
                      active: false,
                      source: "historical",
                    });
                    onRemovingTab();
                  }
                  setOpen(false);
                }}
              />
            <FrResults
              open={overrideOpen}
              onOpen={() => setOverrideOpen(true)}
              onClose={() => setOverrideOpen(false)}
              section={props.section}
              event={get(props, ["details"])}
              overriden={get(log, ["overriden"]) ? log : null}
              dacEventGroup={get(props, ["details", "dacEventGroup"])}
              onlyOverride={true}
              triggerNode={
                <CustomButton
                  variant="contained"
                  color="primary"
                  startIcon={
                    <img src={images.overrideIconWhite} alt="override" />
                  }
                >
                  {I18n.get("site_override")}
                </CustomButton>
              }
              tabs={props.tabs}
              log={props.log}
              isLive={false}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ paddingLeft: "10px" }}>
        <WearingMask
          humanIdentificationEventGroup={get(props, [
            "details",
            "detectionEventGroup",
          ])}
          height={20}
        />
      </Grid>
      <Grid item style={{ marginBottom: "20px" }}>
        <CapturedPhotosContainer
          driver={true}
          photos={getPhotos()}
          nodeTitle={
            <FrResults
              open={frResultsOpen}
              onOpen={() => setFrResultsOpen(true)}
              onClose={() => setFrResultsOpen(false)}
              section={props.section}
              event={get(props, ["details"])}
              overriden={get(log, ["overriden"]) ? log : null}
              dacEventGroup={get(props, ["details", "dacEventGroup"])}
              triggerNode={
                <Box component="span" className={classes.clickableBoxTitle}>
                  {I18n.get("site_capturedPhotosFrResults")}
                </Box>
              }
              tabs={props.tabs}
              isLive={false}
            />
          }
        />
      </Grid>
      {get(log, ["profile", "id"]) && !isUnknownProfile(log.profile.id) && (
        <Grid item>
          <DetailsContainer title={I18n.get("site_matchedProfile")}>
            <ProfileViewMatched
              profileType={1}
              profile={log.profile || {}}
              lov={lov}
              photos={log.profile ? log.profile.images : []}
              disable={{ containerPadding: true, topBar: true }}
            />
          </DetailsContainer>
        </Grid>
      )}
      {props.powerUserMode && (
        <>
          <Grid item xs></Grid>
          <Grid
            item
            style={{
              textAlign: "right",
              fontSize: "0.875em",
              color: colors.black38,
              paddingRight: "10px",
            }}
          >
            {I18n.get("site_eventGroupId") + " "}
            <span style={{ fontStyle: "italic" }}>
              {props.details.detectionId}
            </span>
          </Grid>
        </>
      )}
    </Grid>
  );
};

LogDetailsDriverNew.propTypes = {
  language: PropTypes.string.isRequired,
};

export default LogDetailsDriverNew;
